module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRowWhite",
    staticStyle: {
      "min-width": "1200px",
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n      \t\t 日期：  \n\t          "), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(2)
      }
    }
  }, [_vm._v("前天")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期时间",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "align": "right"
    },
    on: {
      "change": _vm.selectDate
    },
    model: {
      value: (_vm.pdata.sdate),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "sdate", $$v)
      },
      expression: "pdata.sdate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t      \t\t 选择小程序：  \n\t\t         "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入/选择小程序名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t      \t\t 选择渠道：  \n\t          "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入/选择渠道"
    },
    on: {
      "clear": _vm.clearChannel
    },
    model: {
      value: (_vm.chooseChannel.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseChannel, "name", $$v)
      },
      expression: "chooseChannel.name"
    }
  }, _vm._l((_vm.IssuedAldChanneList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.ald_channel,
        "value": item.id
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeChannel(item)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t      \t\t 选择公司：  \n\t          "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.pdata.company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company_id", $$v)
      },
      expression: "pdata.company_id"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t      \t\t 选择状态：  \n\t          "), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择状态"
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.pdata.status),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "status", $$v)
      },
      expression: "pdata.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "正常",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已通知下线",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已确认下线",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t      \t\t 用户操作：  \n\t         "), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showBatchDialog(1)
      }
    }
  }, [_vm._v("批量通知下线")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showBatchDialog(2)
      }
    }
  }, [_vm._v("批量截止下线")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTemp(1)
      }
    }
  }, [_vm._v("批量通知下线模板")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTemp(2)
      }
    }
  }, [_vm._v("批量截止下线模板")])], 1)]), _vm._v(" "), _c('el-row', {
    staticClass: "totalBox"
  }, [_c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("单日总计")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("新增UV")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("UV")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("产品总支出")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("新增占比")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("渠道活跃占比")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("点击单价")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("分发arpu")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("分成后原生arpu")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("总 arpu")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("活跃单日回收")]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v("最高承受单价")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "totalBox"
  }, [_c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.chooseProduct.name))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.visit_uv_new || 0))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.visit_uv || 0))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.cost))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.new_per))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.uv_per))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.click_price))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.arpu_ff))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.arpu_fc))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.arpu))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.uv_back_0))]), _vm._v(" "), _c('el-col', {
    staticClass: "lh45 tc h45",
    attrs: {
      "span": 2
    }
  }, [_vm._v(_vm._s(_vm.cdata.total.hold_price))])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.cdata.list,
      "stripe": "",
      "row-key": "id",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.handleSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "selectable": _vm.selectionDisabled
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "label": "渠道",
      "show-overflow-tooltip": "",
      "min-width": "100",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "公司名称",
      "show-overflow-tooltip": "",
      "min-width": "90",
      "align": "left"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.key == 'atv') ? _c('span', {
            staticClass: "orange",
            on: {
              "click": function($event) {
                return _vm.editAtv(scope.row)
              }
            }
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : (item.key == 'jump_per') ? _c('span', [(scope.row[item.key] != null) ? _c('span', [_vm._v(_vm._s(scope.row[item.key] || 0) + "%")]) : _c('span', [_vm._v("--")])]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "align": "left",
      "width": "330",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(scope.row)
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.notifyOff(scope.$index, scope.row, 0)
            }
          }
        }, [_vm._v("通知下线")]) : _vm._e(), _vm._v(" "), (scope.row.status == 0 || scope.row.status == 2) ? _c('el-button', {
          staticStyle: {
            "width": "130px"
          },
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.notifyOff(scope.$index, scope.row, 1)
            }
          }
        }, [_vm._v("已通知 " + _vm._s(scope.row.update_time.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          staticStyle: {
            "width": "130px"
          },
          attrs: {
            "size": "mini",
            "type": "info",
            "disabled": ""
          }
        }, [_vm._v("已截止 " + _vm._s(scope.row.update_time.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (scope.row.status == 0) ? _c('el-button', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.notifyOff(scope.$index, scope.row, 2)
            }
          }
        }, [_vm._v("截止下线")]) : _vm._e()]
      }
    }])
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详情",
      "visible": _vm.detailDialog,
      "width": "95%"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialog = $event
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_vm._v("\n\t\t\t\t\t\t选择日期：\n\t    \t\t\t"), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal2),
      callback: function($$v) {
        _vm.dateVal2 = $$v
      },
      expression: "dateVal2"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.ddata.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "日期",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "label": "渠道",
      "align": "left"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return (item.key != 'update_time') ? _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(scope) {
          return [(item.key == 'atv') ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": "双击数字可修改获客单价",
              "placement": "top-start"
            }
          }, [_c('span', [_vm._v(_vm._s(item.name)), _c('i', {
            staticClass: "el-icon-question"
          })])]) : _c('span', [_vm._v(_vm._s(item.name))])]
        }
      }, {
        key: "default",
        fn: function(scope) {
          return [(item.key == 'jump_per') ? _c('span', [(scope.row[item.key] != null) ? _c('span', [_vm._v(_vm._s(scope.row[item.key] || 0) + "%")]) : _c('span', [_vm._v("--")])]) : (item.key == 'atv') ? _c('span', {
            staticClass: "orange"
          }, [(scope.row.isEdit == false) ? _c('span', {
            on: {
              "dblclick": function($event) {
                return _vm.atvDetailEdit(scope)
              }
            }
          }, [_vm._v(_vm._s(scope.row[item.key]))]) : _c('span', [_c('el-input', {
            staticClass: "w50",
            attrs: {
              "placeholder": "输入获客单价",
              "size": "mini",
              "autofocus": true
            },
            on: {
              "change": function($event) {
                return _vm.postAtv('detail')
              }
            },
            model: {
              value: (_vm.chooseDetailAtv.atv),
              callback: function($$v) {
                _vm.$set(_vm.chooseDetailAtv, "atv", $$v)
              },
              expression: "chooseDetailAtv.atv"
            }
          })], 1)]) : _c('span', [_vm._v(_vm._s(scope.row[item.key]))])]
        }
      }], null, true)
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑获客单价",
      "visible": _vm.editAtvDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editAtvDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.chooseAtv
    }
  }, [_vm._l((_vm.config), function(it, idx) {
    return _c('el-radio', {
      key: idx,
      attrs: {
        "label": idx + 1
      },
      model: {
        value: (_vm.chooseAtv.type),
        callback: function($$v) {
          _vm.$set(_vm.chooseAtv, "type", $$v)
        },
        expression: "chooseAtv.type"
      }
    }, [_vm._v(_vm._s(it))])
  }), _vm._v(" "), _c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "输入获客单价"
    },
    model: {
      value: (_vm.chooseAtv.atv),
      callback: function($$v) {
        _vm.$set(_vm.chooseAtv, "atv", $$v)
      },
      expression: "chooseAtv.atv"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editAtvDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.postAtv($event)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "edit-channel-discount-dialog",
    attrs: {
      "title": "编辑扣量比例（范围0-1）",
      "visible": _vm.editAldChannelDiscountDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editAldChannelDiscountDialog = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入扣量比例"
    },
    model: {
      value: (_vm.editAldChannelDiscountValue.pr),
      callback: function($$v) {
        _vm.$set(_vm.editAldChannelDiscountValue, "pr", $$v)
      },
      expression: "editAldChannelDiscountValue.pr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editAldChannelDiscountDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.postAldChannelDiscount($event)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.fieldListChange
    },
    model: {
      value: (_vm.FieldIndex),
      callback: function($$v) {
        _vm.FieldIndex = $$v
      },
      expression: "FieldIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "按字段设置",
      "name": "0"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按模块设置",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTapForModel(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _vm._l((_vm.selectFieldListForModel), function(value, key, index) {
    return _c('div', {
      staticClass: "fliedModel"
    }, [_c('div', {
      staticClass: "fliedModelKey"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('draggable', {
      attrs: {
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.isDragging = true
        },
        "end": function($event) {
          _vm.isDragging = false
        }
      },
      model: {
        value: (_vm.selectFieldListForModel[key]),
        callback: function($$v) {
          _vm.$set(_vm.selectFieldListForModel, key, $$v)
        },
        expression: "selectFieldListForModel[key]"
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "tag": "ul"
      }
    }, _vm._l((value), function(item) {
      return _c('li', {
        key: item.key,
        staticClass: "item"
      }, [_c('i', {
        staticClass: "el-icon-rank"
      }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
        staticClass: "el-icon-close",
        on: {
          "click": function($event) {
            return _vm.removeSelectFieldForModel(item, key)
          }
        }
      })])
    }), 0)], 1)], 1)
  })], 2)])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.batchVal == 1 ? '批量通知下线' : '批量截止下线',
      "visible": _vm.batchDialog,
      "width": "1150px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0) ? _c('el-row', {
      key: index,
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        key: idx,
        attrs: {
          "span": 12
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.batchDialog = false
      }
    }
  }, [_vm._v("知道了")])], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5408bca8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/issue/channelDataList.vue
// module id = 1136
// module chunks = 2